import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import resize from '../resize';
Swiper.use([Pagination, Navigation, Lazy]);

const initSuitableSlider = () => {
  const sliderContainer = document.querySelector('.suitable__blocks'),
    chips = document.querySelectorAll('.suitable__master');
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(sliderContainer, {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },

        pagination: {
          el: '.suitable__swiper-pagination',
          bulletActiveClass: 'active',
        },
        on: {
          activeIndexChange: function () {
            changeSlide(this.activeIndex);
          },
        },
      });
    }
  }

  //Смена контента, при смене слайда
  function changeSlide(index) {
    [...chips].map((item, idx) => {
      item.classList.remove('is-active');
      idx == index ? item.classList.add('is-active') : '';
    });
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth < 1024 ? init() : destroy();
  }

  sliderContainer && resizeSwiper();
  sliderContainer && resize(resizeSwiper);
};

export default initSuitableSlider;
